import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import calendarIcon from './images/icon-24-calender-3.svg';
import AbroadPhonesInstructions from '../AbroadPhonesInstructionsBlock/AbroadPhonesInstructions';
import {
  removeFromBoughtPackages,
  updateTicketFromPackageManager,
  setShowAddonPopup,
  setLoading,
  closeModal,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { customerTypeEnum } from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import { isNull } from 'lodash';
import Button from '../../Shared/Buttons/BtnPink';
import { isMobile } from 'react-device-detect';
import AbroadAddonComponent from '../AbroadTicketBlock/AbroadAddons/AbroadAddonComponent';
import AddonTicketPopup from '../AbroadTicketBlock/AbroadAddons/AddonTicketPopup';
import PopUp from '../../Shared/Popup/PopUp';
import Carousel from '../AbroadTicketBlock/Carousel/Carousel';
import OtpValidationResultPopupConstructor from '../CellcomAbroadLobbyBlock/Popups/OtpValidationResultPopupConstructor';
import { removeAbroadPackageMsgBySub  , setReducedSocsForFamilyMember} from 'app/Components/Page/SelfCarePage/SelfCareSlice';
import CallFilterSocMsg from '../AbroadTicketBlock/CallFilterSocMsg';
import { getDataFromIContentRepo  ,buildUrlAndNavigate} from 'app/utilities/StringHelpers/StringHelpers';

import Config from 'app/Config';

const AbroadNewPackageSelfCare = (props) => {
  const [currPackage, setCurrPackage] = useState(null);
  const waze = require('./images/waze-app.svg');
  const facebook = require('./images/facebook-icon.svg');
  const whatsapp = require('./images/whatsapp-app.svg');
  const instagram = require('./images/instagram-app.svg');
  const tiktok = require('./images/tiktok-app.svg');
  const APPS = [waze, facebook, whatsapp, instagram, tiktok];
  const maxAddonsToDisplay = 3; //for carousel
  const [addons, setAddons] = useState([]);
  const [showPopup, setShowPopup] = useState(null);
  const [IsReducedSocList, setIsReducedSocList] = useState(false);
  const [canPurchaseFamilyPackage, setCanPurchaseFamilyPackage] = useState(false);
  const reducedSocsLink= Config.staticWebSiteUrl + getDataFromIContentRepo('linkForReducedPackages')?.url;
  const maxFamilyMembers = 5;
  

  useEffect(() => {

    if (props?.selectedSubscriber?.newAbroadPackage) {
      var currentPackage = props.selectedSubscriber.newAbroadPackage;
      setCanPurchaseFamilyPackage(false);
      if(props.abroadPackages){
        var relatedPackage = props.abroadPackages.find(pack => pack.socName.trim() == currentPackage.socCode.trim());
        if(relatedPackage && relatedPackage.canPurchaseFamilyPackage){
          var reducedSocs = relatedPackage.abroadPackageClient.reducedSocs;
          var reducedSocList = reducedSocs?.reducedSocList?.length>0;
          setIsReducedSocList(reducedSocList);
          if((reducedSocList && (relatedPackage?.familyMembersWithPackages?.length || 0) < reducedSocs?.maxFamilyMembers) || (!reducedSocList && (relatedPackage?.familyMembersWithPackages?.length || 0) < maxFamilyMembers)){
            setCanPurchaseFamilyPackage(true);
          }
        }
      }
      if (currentPackage) {
        setCurrPackage(currentPackage);
        let addonsArr =
          props.selectedSubscriber.abroadAddons?.filter(
            (addon) => addon.parentSocCode == props.selectedSubscriber.newAbroadPackage.socCode,
          ) ?? [];
        setAddons(addonsArr);
      }
    } else {
      setCurrPackage(null);
    }
  }, [props?.selectedSubscriber, props.abroadPackages]);

  useEffect(() => {
    console.log('[AbroadNewPackageSelfCare] purchasedFamilyBundleData:', JSON.stringify(props.purchasedFamilyBundleData));
    console.log('[AbroadNewPackageSelfCare] familyBundleFailedMembers:', JSON.stringify(props.familyBundleFailedMembers));
  }, [props.purchasedFamilyBundleData, props.familyBundleFailedMembers]);

  function getRightDateArr(dateArr) {
    const secondDate = new Date(parseInt(dateArr[2]), parseInt(dateArr[1]) - 1, parseInt(dateArr[0]));
    const today = new Date();
    if (today.getTime() > secondDate.getTime()) return [today.getDate(), today.getMonth() + 1, today.getFullYear()];
    else return [dateArr[0], dateArr[1], dateArr[2]];
  }

  async function getPackageForFamilyMember () {
    if(IsReducedSocList){
     await props.setReducedSocsForFamilyMember({
       socCode: currPackage.socCode,
      });
      await buildUrlAndNavigate(reducedSocsLink);
    }else{
    let customerAbroadPackages = props?.abroadPackages;
    if (customerAbroadPackages) {
      var relatedPackage = customerAbroadPackages?.find(
        (pack) =>
          pack.socName?.trim() == props.selectedSubscriber.newAbroadPackage.socCode &&
          pack.socEffactiveDate == props.selectedSubscriber.newAbroadPackage.startDate,
      );
      const tempDatePickerStartJSFormat = relatedPackage?.effDateILLocalTime.split('.');
      const correctDateArray = getRightDateArr(tempDatePickerStartJSFormat);
      const datePickerStartJSFormat = [correctDateArray[1], correctDateArray[0], correctDateArray[2]].join('/');

      const objToUpdateTicket = {
        selectedPackage: relatedPackage?.familyMemberDiscountedPackage,
        folderType: props?.abroadSlice?.isBusiness ? customerTypeEnum.BUSINESS : customerTypeEnum.PRIVATE,
        selectedStartDate: currPackage?.startDate,
        datePickerStartJSFormat,
        parentStartDate: datePickerStartJSFormat,
        countryList: relatedPackage?.familyMemberDiscountedPackage?.countrySupportedList,
        socCodeParent: relatedPackage?.abroadPackageClient?.socCode,
      };
      setLoading(true);
      await props.updateTicketFromPackageManager(objToUpdateTicket);
      await props.context.navigateTo(props?.iContent?.linkForSaleBlockProcess.expandedValue.url);
    }
  }
  }

  const createCountryStr = () => {
    let countryStr = '';
    currPackage?.selectedCountries?.map((country, index) => {
      if (index === currPackage?.selectedCountries?.length - 1) {
        countryStr += country.countryHebName;
      } else {
        countryStr += country.countryHebName + ', ';
      }
    });
    return `ב${countryStr}`;
  };

  const shekelOrAgourot = (price) => {
    let numPrice = Number(price);
    if (price >= 1) return <>{numPrice} ₪</>;
    else return <>{numPrice * 100} אג'</>;
  };

  const createDetailsStr = () => {
    const details = currPackage?.packageDetailsList?.[0];
    const { voice, sms, data } = details || {};

    const detailsArrData = [
      { value: data?.value, name: 'GB', heName: 'גלישה' },
      { value: voice?.value, name: 'דקות' },
      { value: sms?.value, name: 'SMS' },
    ].filter((d) => !isNull(d.value));

    var isOnlyData = detailsArrData.length == 1 && detailsArrData[0].name == 'GB';
    return (
      <div className='details-string'>
        {detailsArrData.map((item, idx) => {
          const isHebrew = /[\u0590-\u05FF]/.test(item.name);
          return (
            <React.Fragment key={idx}>
              <span className={isHebrew ? 'he' : 'en'}>
                <>
                  {isOnlyData && (
                    <>
                      {' '}
                      <span>{item.heName} </span> &nbsp;
                    </>
                  )}
                  <span>{item.value}</span>
                  {!isOnlyData && <> &nbsp;</>}
                  <span>{item.name}</span>
                </>
              </span>
              {idx < detailsArrData.length - 1 && ' | '}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  const openAddonPopup = (addon) => {
    setShowPopup(addon);
  };

  const getAddons = () => {
    return addons.map((soc, index) => {
      return (
        <AbroadAddonComponent key={index} addon={soc} showPopup={(soc) => openAddonPopup(soc)} closePopup={() => setShowPopup(null)} />
      );
    });
  };

  const removeMsgBySub = () => {
    setCurrPackage(null);
    props.removeAbroadPackageMsgBySub({ subscriberNo: props.selectedSubscriber.productSubscriberNo });
  };
  return (
    <>
      {currPackage != null && (
        <div className='bought-package-container'>
          <div
            className='close-icon'
            onClick={() => {
              removeMsgBySub();
            }}></div>
          <div className='success-header'>
            <svg width='80' height='80' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M60 105.8c-25.252 0-45.8-20.548-45.8-45.8S34.748 14.2 60 14.2s45.8 20.548 45.8 45.8-20.548 45.8-45.8 45.8z'
                stroke='#000'
                strokeWidth='4.4'
              />
              <path d='M37 57.267 54.837 75 83 47' stroke='var(--theme-primary, #810ea9)' strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
            <h2>{currPackage?.isFamilyBundle ? 'חבילה משפחתית הותקנה בהצלחה' : 'החבילה החדשה הותקנה'}</h2>
          </div>
          {currPackage?.isBankOrByUse === 'ByUse' ? (
            <div className='bought-package-byuse-container'>
              <span>חיוב לפי שימוש</span>
              <p>{createCountryStr()}</p>
              <div className='uses-details-container'>
                <div className='use-details'>
                  <p>שיחות</p>
                  <b>
                    <p>{shekelOrAgourot(currPackage?.packageDetailsList[0]?.voice?.priceByUsage)} לדקה</p>
                  </b>
                </div>
                <div className='middle-line'></div>
                <div className='use-details'>
                  <p>הודעות סמס</p>
                  <b>
                    <p>{shekelOrAgourot(currPackage?.packageDetailsList[0]?.sms?.priceByUsage)} להודעה</p>
                  </b>
                </div>
              </div>
            </div>
          ) : (
            <div className='bought-package-details-container'>
              {createDetailsStr()}
              {currPackage?.dataForApp?.isUnlimitedDataForApp && (
                <div className='is-unlimited-data-container'>
                  <p>כולל גלישה חופשית באפליקציות נבחרות</p>
                  <div className='apps-container'>
                    {APPS.map((app, index) => (
                      <Image className='app' key={index} src={app} />
                    ))}
                  </div>
                </div>
              )}
              <div className='calendar-container'>
                <Image src={calendarIcon} />
                <p>{`תחילת חבילה ${currPackage?.startDate.replace(/(\d{4})(\d{2})(\d{2})/, '$3.$2.$1')}`}</p>
              </div>
            </div>
          )}
          {currPackage?.isFamilyBundle && props.purchasedFamilyBundleData && (
            <div className='family-members-section'>
              <p className='family-members-title'>מנויים הכלולים בחבילה</p>
              <div className='family-members-chips'>
                {console.log('[AbroadNewPackageSelfCare render] isFamilyBundle:', currPackage?.isFamilyBundle, '| flightManager:', props.purchasedFamilyBundleData?.flightManager?.phone, '| selectedMembers:', JSON.stringify(props.purchasedFamilyBundleData?.selectedMembers), '| failedMembers:', JSON.stringify(props.familyBundleFailedMembers))}
                {props.purchasedFamilyBundleData.flightManager && !props.familyBundleFailedMembers.includes(props.purchasedFamilyBundleData.flightManager.phone) && (
                  <div className='member-chip'>
                    <p>{props.purchasedFamilyBundleData.flightManager.name && props.purchasedFamilyBundleData.flightManager.name !== '' ? `${props.purchasedFamilyBundleData.flightManager.name} ` : ''}{props.purchasedFamilyBundleData.flightManager.phone}</p>
                  </div>
                )}
                {props.purchasedFamilyBundleData.selectedMembers
                  ?.filter((member) => {
                    const phone = typeof member === 'string' ? member : member?.phone;
                    const isFiltered = props.familyBundleFailedMembers.includes(phone);
                    const isFlightManager = phone === props.purchasedFamilyBundleData.flightManager?.phone;
                    console.log('[AbroadNewPackageSelfCare] member:', phone, '| in failedMembers:', isFiltered);
                    return !isFiltered && !isFlightManager;
                  })
                  .map((member, index) => {
                    const phone = typeof member === 'string' ? member : member?.phone;
                    const name = typeof member === 'object' ? member?.name : null;
                    return (
                      <div className='member-chip' key={index}>
                        <p>
                          {name && name !== '' ? `${name} ` : ''}{phone}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
          {props?.showCallFilterMsg && <CallFilterSocMsg />}
          {canPurchaseFamilyPackage && (
            <Button onclick={() => getPackageForFamilyMember()} text='להוספת חבילה לבן משפחה'></Button>
          )}
          <div className='phones-instructions-container'>
            <p>חשוב להפעיל הגדרות נדידה במכשיר לפני הטיסה</p>
            <AbroadPhonesInstructions />
          </div>
          {getAddons().length > 0 && (
            <>
              <h2>תוספות קטנות שמשדרגות המון</h2>
              {getAddons().length <= maxAddonsToDisplay || isMobile ? (
                <div className='addons-arr' style={{ gridTemplateColumns: `repeat(${addons.length}, 1fr)` }}>
                  {getAddons()}
                </div>
              ) : (
                <div className='addons-carousel'>
                  <Carousel items={addons} maxToDisplay={maxAddonsToDisplay} />
                </div>
              )}
            </>
          )}
          <PopUp
            className='addon-popup-container'
            showPopUp={showPopup != null}
            onClose={() => {
              setShowPopup(null);
            }}>
            <AddonTicketPopup addonToShow={showPopup} closePopup={() => setShowPopup(null)} relatedPackage={currPackage} />
          </PopUp>

          {props.abroadSlice.businessIndividualData.popupData && (
            <div className='addon-result-popup'>
              <PopUp
                showPopUp={props.abroadSlice.isShowPopup}
                onClose={() => {
                  props.closeModal();
                }}>
                <OtpValidationResultPopupConstructor popupData={props.abroadSlice.businessIndividualData.popupData} />
              </PopUp>
            </div>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedSubscriber: state.selfcarePage.selectedSubscriber,
    abroadSlice: state.cellcomAbroad,
    showAddonPopup: state.cellcomAbroad.showAddonPopup,
    abroadPackages: state.selfcarePage.selectedSubscriber?.abroadPackages?.regularPackages,
    showCallFilterMsg: state.cellcomAbroad.selectedAbroadPackage?.showCallFilterMsg,
    purchasedFamilyBundleData: state.cellcomAbroad.purchasedFamilyBundleData,
    familyBundleFailedMembers: state.cellcomAbroad.familyBundleData?.failedMembers || [],
  };
};

const mapDispatchToProps = {
  removeFromBoughtPackages,
  updateTicketFromPackageManager,
  removeAbroadPackageMsgBySub,
  setShowAddonPopup,
  closeModal,
  setReducedSocsForFamilyMember,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadNewPackageSelfCare);
